import React from "react";
import { Phone, FileText, Check } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge, formatDate } from "@/components/admin/StatusBadge";

const Contact = ({ r }) =>
  r.type === "call" ? (
    <span className="text-slate-500 text-sm">Clic sur le numéro{r.button ? ` (bouton ${r.button})` : ""}</span>
  ) : (
    <div className="text-sm">
      <p className="font-medium text-slate-900">{r.name || "—"}{r.is_test && <span className="ml-2 text-[10px] uppercase text-slate-400">test</span>}</p>
      <p className="text-slate-500">{[r.phone, r.email].filter(Boolean).join(" · ")}</p>
      <p className="text-slate-400 text-xs">{[r.postal_code, r.city, r.property].filter(Boolean).join(" · ")}</p>
    </div>
  );

export const LeadsTable = ({ rows }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="leads-table">
    <div className="px-4 py-3 border-b border-slate-100">
      <h2 className="font-semibold text-slate-900 text-base">Leads et appels ({rows.length})</h2>
    </div>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Date</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Contact</TableHead>
          <TableHead>Mot-clé</TableHead>
          <TableHead>Campagne / page</TableHead>
          <TableHead>GCLID</TableHead>
          <TableHead>Verdict du client</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={`${r.type}-${r.id}`} data-testid={`lead-row-${r.id}`}>
            <TableCell className="whitespace-nowrap text-sm text-slate-600">{formatDate(r.date)}</TableCell>
            <TableCell>
              <span className="inline-flex items-center gap-1.5 text-sm text-slate-700">
                {r.type === "call" ? <Phone className="w-4 h-4 text-blue-600" /> : <FileText className="w-4 h-4 text-green-600" />}
                {r.type === "call" ? "Appel" : "Formulaire"}
              </span>
            </TableCell>
            <TableCell><Contact r={r} /></TableCell>
            <TableCell className="text-sm font-medium text-slate-800">{r.keyword || <span className="text-slate-400">—</span>}</TableCell>
            <TableCell className="text-xs text-slate-500">{[r.campaign, r.page].filter(Boolean).join(" · ") || "—"}</TableCell>
            <TableCell>{r.has_gclid ? <Check className="w-4 h-4 text-green-600" /> : <span className="text-slate-400">—</span>}</TableCell>
            <TableCell>
              <StatusBadge status={r.status} />
              {r.decided_at && <p className="text-[11px] text-slate-400 mt-1">le {formatDate(r.decided_at)}</p>}
            </TableCell>
          </TableRow>
        ))}
        {!rows.length && (
          <TableRow><TableCell colSpan={7} className="text-center text-slate-500 py-8">Aucun lead ne correspond aux filtres</TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  </div>
);
